import Navbar from "../../../components/layout/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { MailOpen } from "lucide-react";
import { toast } from "sonner";
import { useEffect, useState } from "react";
import supabase from "../../../helper/supabaseClient";

const Verify = () => {
  const email = localStorage.getItem("verify-email");

  const [hasResentMail, setHasResentMail] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (!email) {
      navigate("/signup");
    }
  }, [email]);

  const handleSendNewEmail = async () => {
    if (hasResentMail) {
      toast.error(
        "You have already resent the verification email. Wait a few minutes before trying again."
      );
      return;
    }

    try {
      if (email) {
        const { data, error } = await supabase.auth.resend({
          type: "signup",
          email,
        });

        if (error) throw error;
      }

      setHasResentMail(true);
      setTimeout(() => setHasResentMail(false), 5 * 60 * 1000); // 5 minutes

      toast.success("Verification email sent successfully!");
    } catch (error: any) {
      toast.error(error.message || "Failed to resend verification email.");
      console.error("Resend verification error:", error);
    }
  };
  return (
    <div>
      <Navbar />
      <div className="p-5 sm:p-14 h-[81vh] flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className=" sm:p-10 rounded-2xl sm:border border-[#7E57C233]  w-[100%] sm:w-[80%] md:w-fit flex items-center justify-between gap-20 ">
            <div className="flex flex-col gap-6 items-start justify-start w-[500px]">
              <h2 className=" flex items-center justify-center gap-2">
                Check email <MailOpen />
              </h2>
              <div className="flex flex-col items-start justify-center gap-5 w-full">
                <span className=" text-[16px]">
                  A verification email has been sent to:{" "}
                  <span className="font-semibold text-[16px]">{email} </span>
                </span>
                <span className="text-wrap items-center justify-center gap-1">
                  Haven't seen email or wrong email?
                  <span
                    onClick={handleSendNewEmail}
                    className={`text-[#945bf5] cursor-pointer ${
                      hasResentMail ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    {" "}
                    Resend email{" "}
                  </span>{" "}
                  or{" "}
                  <Link to="/signup" className="text-[#945bf5] text-wrap">
                    {" "}
                    Back to Signup
                  </Link>{" "}
                </span>
              </div>
            </div>
            <img
              src="/assets/Jellosite-Logo-09.jpg"
              alt=""
              className="w-[250px] hidden md:block"
            />
          </div>
          <ul className="text-[#666666] md:w-full hidden sm:flex gap-3.5 sm:w-[80%]  items-center justify-end mt-1 ">
            <Link to="/privacy_policy">
              <li>Privacy</li>
            </Link>
            <Link to="/terms_conditions">
              <li>Terms</li>
            </Link>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Verify;
